import { TableSelectionEvent } from "@mcleod/components";
import { MapSettings } from "@mcleod/core";
import { AutogenLayoutZoneAreaList } from "./autogen/AutogenLayoutZoneAreaList";
import { MapZoneSelectionUtil } from "./MapZoneSelectionUtil";
import { ZoneMapScreen } from "./MapZoneUtil";

export class ZoneAreaList extends AutogenLayoutZoneAreaList {

    private mapVendor = MapSettings.getSingleton().getZoneMapVendor();
    private mapSelector: MapZoneSelectionUtil;

    override onLoad() {
        this.mainDataSource.search();
        this.mapSelector = new MapZoneSelectionUtil(this.mapVendor, this.mapRoute);
    }

    async tableZoneAreaListOnSelect(event: TableSelectionEvent) {
        await this.mapSelector.handleRowSelection(ZoneMapScreen.ZoneArea, this.tableZoneAreaList.selectedRow);
    }

}
